import React, { useEffect, useState } from "react";
import './App.css';
import GalleryPage from './pages/GalleryPage';
import Homepage from './components/Homepage';
import Navigation from './components/Navigation';
import VenuePage from './pages/VenuePage';
import { Routes, Route } from 'react-router-dom';
import AboutPage from "./pages/AboutPage";
import HappeningPage from "./pages/HappeningPage";
import ContactPage from "./pages/ContactPage";
import PeoplePage from "./pages/PeoplePage";
import GalleryBars from './pages/Gallery/GalleryBars';
// import Elia from './pages/Elia';
// import MazeBar from './pages/MazeBar';
// import Mine from './pages/Mine';
// import Lockhart88 from './pages/Lockhart88';
// import Port from './pages/Port';
// import Taboo from './pages/Taboo';
// import Graffiti from './pages/Graffiti';
// import Gate from './pages/Gate';
// import TheStation from './pages/TheStation';
// import Centrico from './pages/Centrico';
import JoinUs from './pages/JoinUs';
import { useDispatch, useSelector } from "react-redux";
import { getStoreInfo, loadApi } from "./redux/api/actions";
import { Spinner } from "react-bootstrap";

function App() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true)

  const mamaApi = useSelector((state) => state.apiReducer);

  const getInfo = async () => {
    await getStoreInfo().then((response) => {
      dispatch(loadApi(response.data))
      setLoading(false)
    })
  }

useEffect(() => {
    getInfo()
  }, []);

  return loading === true ? (
    <div className="loading">
      <Spinner animation="border" role="status" variant="dark"/>
    </div>
  ) : (
    <div className="App">
      <div className="navigation">
        <Navigation {...mamaApi.store}/>
      </div>
      <Routes>
        <Route path="/" element={<Homepage {...mamaApi} />}/>
        <Route path="/home" element={<Homepage {...mamaApi} />}/>
        <Route path="/gallery" element={<GalleryPage {...mamaApi} />}/>
        <Route path="/venue" element={<VenuePage {...mamaApi} />} />
        <Route path="/about" element={<AboutPage {...mamaApi} />} />
        <Route path="/happenings" element={<HappeningPage {...mamaApi} />} />
        <Route path="/contact" element={<ContactPage {...mamaApi} />} />
        <Route path="/joinus" element={<JoinUs {...mamaApi} />} />
        <Route path="/people" element={<PeoplePage {...mamaApi.galleryCategories[2]} />} />
        <Route path="/gallery/ELIA" element={<GalleryBars {...mamaApi} />} />
        <Route path="/gallery/MINE" element={<GalleryBars {...mamaApi} />} />
        <Route path="/gallery/MAZE%20BAR" element={<GalleryBars {...mamaApi} />} />
        <Route path="/gallery/LOCKHART%2088" element={<GalleryBars {...mamaApi} />} />
        <Route path="/gallery/PORT" element={<GalleryBars {...mamaApi} />} />
        <Route path="/gallery/TABOO" element={<GalleryBars {...mamaApi} />} />
        {/* <Route path="/gallery/GRAFFITI" element={<GalleryBars {...mamaApi} />} /> */}
        <Route path="/gallery/GATE" element={<GalleryBars {...mamaApi} />} />
        <Route path="/gallery/THE%20STATION" element={<GalleryBars {...mamaApi} />} />
        <Route path="/gallery/CENTRICO" element={<GalleryBars {...mamaApi} />} />
      </Routes>
    </div>
  );
}

export default App;
